import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getCreateWorldCupGroupStep2FormStyles = (theme: Theme) =>
  StyleSheet.create({
    root: { flexDirection: 'column', gap: 10 },
    sectionLabel: {
      fontSize: 9,
      fontWeight: '800',
      color: theme.primary,
      letterSpacing: 1.4,
      textTransform: 'uppercase',
      marginBottom: 6,
    },
    chipGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
    },
    chip: {
      width: '30%',
      flexGrow: 1,
      paddingVertical: 12,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.gray[200],
      backgroundColor: 'rgba(255,255,255,0.04)',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    },
    chipActive: {
      borderWidth: 1.5,
      borderColor: theme.accent,
      backgroundColor: `${theme.accent}22` as never,
    },
    chipCoinRow: { flexDirection: 'row', alignItems: 'center', gap: 4 },
    chipCoinIcon: { width: 16, height: 16 },
    chipText: { fontSize: 14, fontWeight: '800', color: theme.gray[900] },
    chipTextActive: { color: theme.accentDark },
    chipFreeText: { fontSize: 14, fontWeight: '800', color: theme.accent },
    customRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginTop: 2,
    },
    customOrText: { fontSize: 11, color: theme.gray[500] },
    customInputWrap: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      backgroundColor: theme.background.primary,
      borderWidth: 1,
      borderColor: theme.gray[200],
      borderRadius: 10,
      paddingHorizontal: 10,
      paddingVertical: 8,
    },
    customCoinIcon: { width: 16, height: 16 },
    customInput: {
      flex: 1,
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[900],
    },
    potSplitCard: {
      borderRadius: 14,
      borderWidth: 1,
      borderColor: theme.gray[200],
      backgroundColor: 'rgba(255,255,255,0.04)',
      padding: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },
    potSplitCardActive: {
      borderWidth: 1.5,
      borderColor: theme.primary,
      backgroundColor: `${theme.primary}22` as never,
    },
    potSplitBarsWrap: { width: 72, flexShrink: 0 },
    potSplitCardBody: { flex: 1, minWidth: 0 },
    potSplitCardName: {
      fontSize: 13,
      fontWeight: '800',
      color: theme.gray[900],
    },
    potSplitCardDesc: { fontSize: 10, color: theme.gray[500], marginTop: 2 },
    potSplitRadio: {
      width: 18,
      height: 18,
      borderRadius: 9,
      borderWidth: 1.5,
      borderColor: theme.gray[400],
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    potSplitRadioActive: { borderColor: theme.primary, backgroundColor: theme.primary },
    potSplitRadioDot: { width: 6, height: 6, borderRadius: 3, backgroundColor: theme.onPrimary },
    pctRow: { flexDirection: 'row', gap: 10 },
    pctField: { flex: 1 },
    pctLabel: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[500],
      marginBottom: 5,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    pctInput: {
      borderRadius: 10,
      paddingHorizontal: 6,
      paddingVertical: 10,
      backgroundColor: theme.background.card,
      borderWidth: 1.5,
      borderColor: theme.gray[200],
      fontSize: 15,
      fontWeight: '700',
      color: theme.gray[900],
      textAlign: 'center',
    },
    errorText: { fontSize: 12, color: theme.error, marginTop: 2 },
    potBarsContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 3,
      height: 28,
    },
    potBarsItemWrap: {
      flex: 1,
      alignItems: 'center',
      gap: 2,
    },
    potBarsBar: {
      width: '100%',
      borderRadius: 3,
    },
    potBarsLabel: {
      fontSize: 8,
      fontWeight: '700',
    },
  });

export type CreateWorldCupGroupStep2FormStyles = ReturnType<typeof getCreateWorldCupGroupStep2FormStyles>;
